import { Icon, IconProps, Link } from '@cloudscape-design/components';
import { useTranslate } from 'src/i18n/useTranslate';
import InfoPageTemplate from 'src/templates/info-page-template/info-page-template';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import initialMetricsPublisher from 'src/metrics';
import * as KatalMetrics from '@amzn/katal-metrics';

import './error-page.scss';
import { truncateString } from 'src/utils/utils';
import { ErrorTicketResponse } from 'src/types/errorResponse';

const ErrorPage = ({ ticketUrl }: { ticketUrl?: string }) => {
    const t = useTranslate();
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as ErrorTicketResponse;

    useEffect(() => {
        const errorPageMetricsPublisher =
            initialMetricsPublisher.newChildActionPublisherForMethod(
                'ErrorPageView'
            );

        const errorPageData = {
            url: truncateString(window.location.href),
            referrer: truncateString(document.referrer),
            timestamp: new Date().toISOString(),
        };

        errorPageMetricsPublisher.publish(
            new KatalMetrics.Metric.String(
                'gru.error.page.view',
                JSON.stringify(errorPageData)
            )
        );
    }, []);

    const buttonProps = {
        iconName: 'caret-left-filled' as IconProps.Name,
        onClick: () => navigate('/'),
        text: t('not_found_go_home_button', 'Go to homepage'),
    };

    const ticket = ticketUrl ? ticketUrl : state?.ticketUrl;
    return (
        <InfoPageTemplate
            headerText={t('error_header', 'Something went wrong')}
            icon={
                <Icon name="status-negative" size="inherit" variant="error" />
            }
            buttonProps={buttonProps}
        >
            <div style={{ margin: '16px' }}>
                {`${t(
                    'error_page_detail',
                    "We've encountered an unexpected error"
                )}.`}
                {ticket && (
                    <div className={'not-found-info'}>
                        {t(
                            'error_page_auto_gen',
                            "We've automatically generated a ticket for you: "
                        )}
                        <Link href={ticket} target="_blank">
                            <Icon name="external" />
                        </Link>
                    </div>
                )}
            </div>
        </InfoPageTemplate>
    );
};

export default ErrorPage;
